module.exports = __webpack_public_path__ + "img/bbb00bf.jpg";